/* eslint-disable camelcase */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Header from './header';
import PostsContainer from '../container';
// import Cookies from 'js-cookie';
import get from 'lodash/get';
import { isUndefined } from 'util';

export default class Insert extends Component {
  constructor(props) {
    super(props);

    this.state = {
      active: true
    };
  }

  UNSAFE_componentWillMount() {
    const { expand = null } = this.props;

    if (expand) {
      // have to convert dfp string val to a bool
      let shouldExpand;
      if (!isUndefined(expand)) {
        // console.log('expand is not undefined', expand);
        if (expand !== 'true') {
          shouldExpand = false;
        } else {
          shouldExpand = true;
        }

        // console.log('we have an expand value', shouldExpand);

        this.setState({ active: shouldExpand }, () => {
          // console.log('active set', shouldExpand);
        });
      } else {
        // console.log('insert.props.expand is undefined');
      }
    }
  }

  componentDidMount() {
    // console.log('🚨 insert mounted!!')
  }

  shouldComponentUpdate() {
    return false;
  }

  setActive() {
    this.state.active = true;
    this.forceUpdate();
  }

  render() {
    const {
      config,
      tags,
      postData,
      related,
      isDesktop,
      isFirstPost,
      pageNum,
      live,
      insert,
      event
    } = this.props;
    // const abGroupCookie = Cookies.get('abgroup');

    return (
      <div
        className={
          postData.cardType === 'Sponsored Story'
            ? 'sponsored_article__insert'
            : 'article__insert'
        }
      >
        <div>
          {this.state.active ? (
            <PostsContainer
              key={get(postData, 'id')}
              posts={[postData]}
              related={related}
              isDesktop={isDesktop}
              pageNum={pageNum}
              config={config}
              mic2020Companies={this.props.mic2020Companies}
              mic2020Regions={this.props.mic2020Regions}
              mic2020Sectors={this.props.mic2020Sectors}
              postPromoterArticleText={this.props.postPromoterArticleText}
              event={event}
              tags={tags}
            />
          ) : (
            ''
          )}
          <div
            className={
              this.state.active
                ? 'article__preview--active'
                : 'article__preview'
            }
          >
            <Header
              tags={tags}
              advertorial={false}
              post={postData}
              isFirstPost={isFirstPost}
              isLongPost={false}
              isVideoPost={false}
              live={live}
              config={config}
              insert={insert}
            />

            <div
              className="article__preview__body"
              dangerouslySetInnerHTML={{
                __html: get(postData, 'content[0]')
              }}
            />
            <button onClick={() => this.setActive()}>Read More</button>
          </div>
          {/* {   ) : (
            ''
          )} */}
        </div>
      </div>
    );
  }
}

Insert.defaultProps = {
  isDesktop: false,
  isFirstPost: false,
  related: [],
  live: false,
  expand: undefined,
  mic2020Companies: [],
  mic2020Regions: [],
  mic2020Sectors: [],
  postPromoterArticleText: '',
  event: null
};

Insert.propTypes = {
  config: PropTypes.shape({}).isRequired,
  tags: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  postData: PropTypes.shape({}).isRequired,
  insert: PropTypes.bool.isRequired,
  pageNum: PropTypes.number.isRequired,
  related: PropTypes.arrayOf(PropTypes.shape({})),
  isDesktop: PropTypes.bool,
  isFirstPost: PropTypes.bool,
  live: PropTypes.bool,
  expand: PropTypes.string,
  mic2020Companies: PropTypes.arrayOf(PropTypes.shape()),
  mic2020Regions: PropTypes.arrayOf(PropTypes.shape()),
  mic2020Sectors: PropTypes.arrayOf(PropTypes.shape()),
  postPromoterArticleText: PropTypes.string,
  event: PropTypes.string
};
